<template>
  <div class="statictics section-pad">
    <div class="container">
      <h3 class="text-center">{{ $t('statsView.appStatistics') }}</h3>
      <p class="text-center title-p gray-col">
        {{ $t('statsView.appDescription') }}
      </p>
      <div class="stats-boxes text-center">
        <div class="row">
          <div class="col-lg-3 col-md-4 col-6 m-top-20">
            <div class="goal-flex">
              <div class="stats-rel-num" >{{ introSite.users_count }}</div>
              <span>+</span>
            </div>
            <div class="stats-num">{{ $t('statsView.customersCount') }}</div>
          </div>
          <div class="col-lg-3 col-md-4 col-6 m-top-20">
            <div class="goal-flex">
              <div class="stats-rel-num" >{{ introSite.owners_count }}</div>
              <span>+</span>
            </div>
            <div class="stats-num">{{ $t('statsView.ownersCount') }}</div>
          </div>
          <div class="col-lg-3 col-md-4 col-6 m-top-20">
            <div class="goal-flex">
              <div class="stats-rel-num" >{{ introSite.managers_count }}</div>
              <span>+</span>
            </div>
            <div class="stats-num">{{ $t('statsView.registeredCount') }}</div>
          </div>
          <div class="col-lg-3 col-md-4 col-6 m-top-20">
            <div class="goal-flex">
              <div class="stats-rel-num">{{ introSite.downloads }}</div>
              <span>+</span>
            </div>
            <div class="stats-num">{{ $t('statsView.downloadsCount') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted , defineProps } from "vue";
// reactive states

// props
const props = defineProps(["introSite"]);

// functions

// mounted
onMounted(() => {
  console.log(props);
});
</script>
